/* istanbul ignore file */
import RadioInput from './RadioInput';

export default RadioInput;
